import { EntityListResponse, EntityListTypeName } from '@ydistri/api-sdk';
import { useMemo } from 'react';
import { getDefaultEntityListsParams, useGetEntityListsQuery } from './apiEntityLists';

interface AdministrationEntityLists {
  data: EntityListResponse[] | undefined;
  isFetching: boolean;
  fulfilledTimeStamp: number | undefined;
}

/** The administration's lists of a type: it never shows a list whose data were deleted, also with the archived toggle. */
const useAdministrationEntityLists = (
  entityListType: EntityListTypeName,
): AdministrationEntityLists => {
  const {
    data: entityLists,
    isFetching,
    fulfilledTimeStamp,
  } = useGetEntityListsQuery(getDefaultEntityListsParams(entityListType));

  const data = useMemo(
    () => entityLists?.filter(entityList => !entityList.isDataDeleted),
    [entityLists],
  );

  return { data, isFetching, fulfilledTimeStamp };
};

export default useAdministrationEntityLists;
